import React from 'react';
import { Container } from 'react-bootstrap';
import Layout from './Layout';

class EmailVerification extends React.Component {
    public render(): JSX.Element {
        return (
            <Layout>
                <div className='broker'>
                    <Container className='email-verification'>
                        <h3>Email Verification Required</h3>
                        <p className='intro'>Please check your email for a verification link. Don't forget to check your spam folder.</p>
                    </Container>
                </div>
            </Layout>
        );
    }
}

export default EmailVerification;
